import { Task } from '../model/types/tasks';
import { TasksInformationSchema } from '../model/types/tasksInformationSchema';

type TasksInformationData = Omit<TasksInformationSchema, 'error' | 'isLoading'>;

export const getTags = (taskData: Task, tasksInformationData: TasksInformationData): string[] => {
    const taskTagsNumbers = taskData.context?.tags;
    if (!taskTagsNumbers) {
        return [];
    }
    const tagsFromStore = tasksInformationData.tags.filter((tag) =>
        taskTagsNumbers.includes(tag.id)
    );
    return tagsFromStore.map((tag) => tag.title);
};
